import React, { FC } from "react"
import classes from "./ModuleContainer.module.scss"
import { IModuleContainer } from "./ModuleContainer.interface"

const ModuleContainer: FC<IModuleContainer> = ({ children }) => {
  return (
    <div className={classes.moduleRoot}>
      <div className={classes.moduleContainer}>{children}</div>
    </div>
  )
}

export default ModuleContainer
